import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/landing/Reveal";

const faqs = [
  {
    id: "flights",
    q: "What are the best flight timings from South India?",
    a: "Guwahati (GAU) is the gateway. Most direct and one-stop flights from Bangalore, Chennai, Hyderabad and Kochi land by early afternoon — perfect for our relaxed Day 1 Umiam Lake stop. We time your Day 6 departure transfer precisely around your return flight so there's never a rushed airport dash.",
  },
  {
    id: "food",
    q: "Are South Indian and pure-veg food options available?",
    a: "Absolutely. Our stays and partner cafés are vetted for South Indian and Jain/pure-veg comforts — idli, dosa, sambar, curd rice and familiar spices are arranged in advance. Tell us your household's preferences and we brief every kitchen before you arrive.",
  },
  {
    id: "connectivity",
    q: "Will I have network connectivity for quick work checks?",
    a: "Shillong, Sohra and your eco-resorts have reliable 4G and Wi-Fi for calls and email. Remote valleys (like the Root Bridge trek) have patchy signal by design — but we schedule these as opt-in, so you can stay reachable on the days that matter.",
  },
  {
    id: "safety",
    q: "Is the road travel safe and comfortable for elders?",
    a: "Yes. We use well-maintained Toyota Innova Crystas with experienced local drivers, unhurried pacing, and frequent comfort breaks. Mountain roads are handled by our vetted ground team — so elders and kids stay comfortable and safe throughout.",
  },
];

export const Faqs = () => (
  <section className="bg-white px-7 py-24 sm:px-12 lg:px-20 lg:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-4xl">
      <Reveal className="mb-14">
        <p className="eyebrow text-gold mb-5">Regional Travel Questions</p>
        <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl">
          Answering your <span className="italic text-gold">regional questions.</span>
        </h2>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-b border-black/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${f.id}`}
                className="py-6 text-left font-display text-lg text-ink hover:no-underline hover:text-gold [&[data-state=open]]:text-gold"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-black/60">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
